import { Input } from 'antd'
import { createStyles } from 'antd-style'

import { useUrlParams } from '@eastcoal/common/hooks/useUrlParams'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { useNavigate } from '@eastcoal/router/exports/react-router'
import { EastcoalLogo } from '@eastcoal/shared/components/EastcoalLogo'

import { SEARCH_RESULT_PAGE_PATH } from '../../../pages/Search/constants/path'

const useStyles = createStyles(({ token }) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    alignItems: 'center',
    paddingBlockStart: token.paddingXL,
    paddingBlockEnd: token.paddingMD * 2
  }
}))

export const LayoutTopbar = () => {
  const navigate = useNavigate()

  const onSearch = (search: string) => {
    navigate(
      stringifyUrl({
        url: SEARCH_RESULT_PAGE_PATH,
        query: { search }
      })
    )
  }

  const { search } = useUrlParams()

  const { styles } = useStyles()

  return (
    <div className={styles.container}>
      <div>
        <EastcoalLogo large link='/' />
      </div>
      <Input.Search
        allowClear
        defaultValue={search}
        enterButton='搜索'
        placeholder='请输入关键字'
        onSearch={onSearch}
      />
    </div>
  )
}
